import { PageHeader } from "../../components/Header";
import { PageFooter } from "../../components/Footer";
import { DialogHeader } from "../../components/Header";
import LateralityButton from "./LateralityButton";
import useSelectivity from "./hooks/useSelectivity";
import Button from "../../components/Button";
import useLang from "../../hooks/useLang";

const Selectivity = (props) => {
  const lang = useLang();
  const {
    okButtonAttribs,
    mistakeButtonAttribs,
    backButtonAttribs,
    showBackButton,
  } = useSelectivity(props);

  return (
    <>
      <PageHeader {...props?.header} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <DialogHeader title={`${props?.frequency} Hz`} centered />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "var(--gap-base)",
        }}
      >
        <LateralityButton {...okButtonAttribs} />
        <LateralityButton {...mistakeButtonAttribs} />
      </div>
      {showBackButton ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "var(--padding-article-header)",
          }}
        >
          <Button {...backButtonAttribs}>{lang("captions.undo")}</Button>
        </div>
      ) : null}
      <PageFooter {...props?.footer} />
    </>
  );
};

export default Selectivity;
